import moment from 'moment';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { formatDate, formatNumber } from '../../utils';

import { ButtonLink } from '../Button';

const getTodayDateRange = () => ({
  startDate: moment().utcOffset(0),
  endDate: moment().utcOffset(0),
});

const Slash = () => <span>&nbsp;/&nbsp;</span>;

const RecordsInfoComponent = (props) => {
  const {
    count,
    todayCount,
    tableDataType,
    launchDate,
    isDateSelected,
    startDate,
    endDate,
    usersCount,
    hasFilterByDate,
    onDateRangeChange,
  } = props;
  const dateFormat = 'MM/DD/YY';
  const from = formatDate(startDate, true, dateFormat);
  const to = formatDate(endDate, true, dateFormat);
  let todayCountInfo = (
    <>
      <Slash />
      {formatNumber(todayCount)}
      <span>&nbsp;today</span>
    </>
  );
  if (hasFilterByDate) {
    todayCountInfo = (
      <>
        <Slash />
        <ButtonLink
          component="button"
          variant="body1"
          onClick={() => onDateRangeChange(getTodayDateRange())}
          color="primary"
        >
          {`${formatNumber(todayCount)} today`}
        </ButtonLink>
      </>
    );
  }
  return count || count === 0 ? (
    <Box display="flex" alignItems="center" maxWidth="80%" id="records_info">
      {count ? formatNumber(count) : 'No'} {tableDataType(count)}
      {launchDate && !from
        ? ` since launch at ${moment(launchDate).format('MM/DD/YYYY')}`
        : null}
      {isDateSelected && from ? ` from ${from}` : null}
      {isDateSelected && to ? ` to ${to}` : null}
      {usersCount || usersCount === 0
        ? ` / ${formatNumber(usersCount)} are registered`
        : null}
      {todayCount || todayCount === 0 ? todayCountInfo : null}
    </Box>
  ) : null;
};

RecordsInfoComponent.defaultProps = {
  tableDataType: (count) => pluralize('record', count),
  count: null,
  todayCount: null,
  usersCount: null,
  launchDate: null,
  startDate: null,
  endDate: null,
};

RecordsInfoComponent.propTypes = {
  tableDataType: PropTypes.func,
  onDateRangeChange: PropTypes.func.isRequired,
  isDateSelected: PropTypes.bool.isRequired,
  hasFilterByDate: PropTypes.bool.isRequired,
  count: PropTypes.number,
  todayCount: PropTypes.number,
  usersCount: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  launchDate: PropTypes.string,
};

export default RecordsInfoComponent;
